import { useNavigate } from "react-router-dom";
import { MapPinIcon, CalendarIcon, UserIcon } from "@heroicons/react/24/outline";
import { useState, useEffect } from "react";
import axios from "axios";

export default function SearchBar() {
    const [form, setForm] = useState({
        destination: "",
        checkIn: "",
        checkOut: "",
        guests: 1,
    });

    const navigate = useNavigate();
    const [destinations, setDestinations] = useState([]);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!form.destination.trim()) {
            alert("Please enter the destination");
            return;
        }

        navigate("/search-hotels", { state: form });
    };

    useEffect(() => {
        axios.get("https://hotel.southtravels.com/api/destinations")
            .then((res) => {
                setDestinations(res.data);
            })
            .catch((err) => console.log(err));
    }, []);

    return (
        <div className="bg-gradient-to-r from-teal-400 to-cyan-500 shadow-xl hover:shadow-2xl transition p-6 max-w-6xl mx-auto relative z-20 px-4 sm:px-6 mt-0 lg:-mt-16 rounded-none lg:rounded-2xl">
            <h2 className="text-white text-2xl md:text-3xl font-bold mb-6 text-center">
                Find Your Perfect Hotel
            </h2>

            <form
                onSubmit={handleSubmit}
                className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 items-end w-full min-w-0 overflow-hidden"
            >
                {/* Destination */}
                <div className="min-w-0 w-full">
                    <label className="text-white font-semibold mb-1 block">
                        Destination
                    </label>

                    <div className="relative flex items-center">
                        <MapPinIcon className="w-5 h-5 absolute left-3 text-gray-400 pointer-events-none" />

                        <select
                            name="destination"
                            value={form.destination}
                            onChange={handleChange}
                            className="w-full h-[40px] pl-10 pr-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-white text-gray-800 appearance-none"
                        >
                            <option value="">Select Destination</option>

                            {destinations.map((dest) => (
                                <option key={dest.id} value={dest.name}>
                                    {dest.name}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* Check-in */}
                {/* Check-in */}
                <div className="flex flex-col min-w-0 w-full">
                    <label className="text-white font-semibold mb-1 block">
                        Check-in
                    </label>

                    <input
                        type="date"
                        name="checkIn"
                        value={form.checkIn}
                        onChange={handleChange}
                        className="w-full min-w-0 max-w-full block h-[40px] pl-10 pr-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-white text-gray-800 appearance-none"
                    />
                </div>

                {/* Check-out */}
                {/* Check-out */}
                <div className="flex flex-col min-w-0 w-full">
                    <label className="text-white font-semibold mb-1 block">
                        Check-out
                    </label>

                    <input
                        type="date"
                        name="checkOut"
                        value={form.checkOut}
                        onChange={handleChange}
                        className="w-full min-w-0 max-w-full block h-[40px] pl-10 pr-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-white text-gray-800 appearance-none"
                    />
                </div>

                {/* Guests */}
                <div className="min-w-0 w-full">
                    <label className="text-white font-semibold mb-1 block">
                        Guests
                    </label>

                    <div className="relative flex items-center">
                        <UserIcon className="w-5 h-5 absolute left-3 text-gray-400 pointer-events-none" />

                        <select
                            name="guests"
                            value={form.guests}
                            onChange={handleChange}
                            className="w-full h-[40px] pl-10 pr-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-white text-gray-800 appearance-none"
                        >
                            {[1, 2, 3, 4, 5, 6].map((num) => (
                                <option key={num} value={num}>
                                    {num}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* Button */}
                <div className="sm:col-span-2 lg:col-span-1 flex items-end mt-3">
                    <button
                        type="submit"
                        className="w-full h-[40px] bg-white text-teal-600 font-bold px-6 rounded-lg shadow-lg hover:bg-gray-100 transition transform hover:scale-105 flex items-center justify-center gap-2"
                    >
                        <span>Search Hotels</span>

                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-5 h-5"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M21 21l-4.35-4.35M17 11a6 6 0 11-12 0 6 6 0 0112 0z"
                            />
                        </svg>
                    </button>
                </div>
            </form>
        </div>
    );
}